<template>
  <div class="password-style">
    <div class="header-psw">
      <img :src="setLogoImg" alt="logo" class="logo" />
      <div class="line">重置密码</div>
      <div class="go-login" @click="commitEnd">返回登录</div>

    </div>
    <div class="info">
      <div class="step">
          <Steps :current="stepCurrent">
              <Step title="输入账号"></Step>
              <Step title="重置密码"></Step>
              <Step title="重置完成"></Step>
          </Steps>
      </div>
      <div class="check-info" v-if="stepCurrent==0">
        <Input v-model="telephone" placeholder="请输入手机号码" style="width: 300px" />
        <div class="checkbox" v-if="!checkStatus">
          <div class="checkbox-info" @click="handleCheckphone" style="cursor: pointer">
            <img :src="imgSrc" />
            点击验证手机号
          </div>
        </div>
        <!-- 验证通过 -->
        <div class="checkbox" v-else>
          <div class="checkbox-info">
            <Icon type="md-checkmark" />
            验证通过
          </div>
        </div>
         <div class="checkbox">
          <div class="checkbox-info yzm">
            <input v-model="yzm" :disabled="disabledCode" placeholder="请输入短信验证码" style="width:180px" />
            <span v-if="!checkStatus">获取验证码</span>
            <span v-if="checkStatus && !setTime" @click="getCode" style="cursor: pointer">获取验证码</span>
            <!-- <span v-if="checkStatus && setTime">获取验证码</span> -->
            <span v-if="checkStatus && setTime">重新发送({{timestart}}s)</span>
          </div>

        </div>
         <div class="submit">
           <Button size="large" type="primary" @click="commit">确定</Button>
         </div>
      </div>
      <div class="check-info" v-if="stepCurrent==1">
        <div class="reset-style">
          <Input v-model="setPsw" placeholder="请设置6位以上登录密码" style="width: 300px" @input="inputInit"/>
        </div>
        <div class="passtype">密码强度
          <span :class="{'passStrong':passStrong=='较弱'}">较弱</span>
          <span :class="{'passStrong':passStrong=='一般'}">一般</span>
          <span :class="{'passStrong':passStrong=='较强'}">较强</span>
          <span :class="{'passStrong':passStrong=='很强'}">很强</span>
        </div>
        <div class="reset-style">
          <Input v-model="commitPsw" placeholder="请确认登录密码" style="width: 300px" />
       </div>

        <div class="submit">
           <Button size="large" type="primary" @click="commit" v-if="stepCurrent==0">确定</Button>
           <Button size="large" type="primary" @click="commitNext" v-if="stepCurrent==1">确定</Button>

         </div>
      </div>
      <div class="checkfinish" v-if="stepCurrent==2">
        <Button size="large" type="primary" @click="commitEnd">重置完成，点击返回登录界面</Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "resetPassword",
  components: {},
  data() {
    return {
      timestart:30,
      input: '',
      passStrong: '',
      stepCurrent:0,
      telephone:'',
      yzm:'',
      checkStatus:0,
      disabledCode:true,
      setPsw:'',
      commitPsw:'',
      hash:'',
      setTime:false,
    };
  },
  computed: {
    imgSrc () {
       return window.oss+ '/img/check.png';
    },
    setLogoImg () {
       return window.oss+ '/img/loginLogo1.png';
    },
  },
  methods: {
    inputInit(val) {
      if (!val) {
        this.passStrong = ''
        return false
      }
      var count = 0
      var digital = /[0-9]/;
      var capital = /[A-Z]/;
      var lowercase = /[a-z]/;
      var spec = /[,.<>{}~!@#$%^?;&*_]/;

      if (digital.test(val)) {
        count ++
      }
      if ( spec.test(val)) {
        count ++
      }
      if (lowercase.test(val) ) {
        count ++
      }
      if (capital.test(val)) {
        count ++
      }
      switch (count) {
        case 1:
          this.passStrong = '较弱'
          return false
        case 2:
          this.passStrong = '一般'
          return false
        case 3:
          this.passStrong = '较强'
          return false
        case 4:
          this.passStrong = '很强'
          return false
        default:
          this.passStrong = ''
          return false
      }
    },
    // inputInit(val) {
    //     if (!val) {
    //       this.passStrong = ''
    //       return false
    //     }
    //     //var enoughRegex = new RegExp("(?=.{6,}).*", "g")
    //     var mediumRegex = new RegExp("^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$", "g")
    //     var strongRegex2 = new RegExp("^(?=.{6,})((?=.*\d)(?=.*[a-z])(?!.*[A-Z\W]).*$|((?=.*\d)(?=.*[A-Z])(?!.*[a-z\W]).*$)|((?=.*\d)(?=.*\W)(?!.*[a-zA-Z]).*$)|((?=.*[a-z])(?=.*[A-Z])(?!.*[\d\W]).*$)|((?=.*[a-z])(?=.*\W)(?!.*[\dA-Z]).*$)|((?=.*[A-Z])(?=.*\W)(?!.*[\da-z]).*$))", "g")
    //     var strongRegex3 = new RegExp("(^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$)")
    //     var stongerRegex4 = new RegExp("^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!#@*&.])[a-zA-Z\d!#@*&.]*$")
    //     console.log('-------',val);
    //     if (/^(?=.{6,})((?=.*\d)(?!.*[a-zA-Z\W]).*$|((?=.*[a-z])(?!.*[\dA-Z\W]).*$)|((?=.*[A-Z])(?!.*[\da-z\W]).*$)|((?=.*\W)(?!.*[\da-zA-Z]).*$))/.test(val)) { //6位以上任意一种
    //       this.passStrong = '较弱'
    //       return false
    //     } else if (/^(?=.{6,})((?=.*\d)(?=.*[a-z])(?!.*[A-Z\W]).*$|((?=.*\d)(?=.*[A-Z])(?!.*[a-z\W]).*$)|((?=.*\d)(?=.*\W)(?!.*[a-zA-Z]).*$)|((?=.*[a-z])(?=.*[A-Z])(?!.*[\d\W]).*$)|((?=.*[a-z])(?=.*\W)(?!.*[\dA-Z]).*$)|((?=.*[A-Z])(?=.*\W)(?!.*[\da-z]).*$))/.test(val)) { //6位以上任意二种
    //       this.passStrong = '一般'
    //       return false
    //     } else if (/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{6,24}$/.test(val)) { //6位以上任意三种
    //       this.passStrong = '很强'
    //       return false
    //     }
    //     else if(/^(?=.{6,})(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*\W).*$/.test(val)){ //6位以上任意四种
    //       this.passStrong = '较强'
    //       return false
    //     }
    //     else {
    //       this.passStrong = ''
    //       return false
    //     }
    // },
    timerFn(){
      var timestart = 30
      let time = setInterval(() => {
        timestart-=1
        if(timestart==0){
            console.log("倒计时结束")
            clearTimeout(time)
            this.setTime = false
          }

          this.timestart = timestart
        }, 1000);
      },

    handleCheckphone(){
      let reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
      if(!this.telephone){
        this.$message.warning("请先输入手机号码!");
        return
      }
      if(!reg.test(this.telephone)){
        this.$message.warning("请输入正确格式的手机号码!");
        return
      }
      $network
        .post(
          `/p/c/validateTel`,
          {
            "tel":this.telephone
          }
        ).then((res)=>{
          const {data:{code,message}} = res
          if(code==0){
            this.checkStatus = 1
            this.disabledCode = false
          }
      })
    },
    getCode(){
      this.timerFn()
      this.setTime = true
      $network.post(
        `/p/c/sendVerificationCode`,
        {
          "tel":this.telephone
        }
      ).then((res)=>{
        const {data:{code,message}} = res
        console.log("获取验证码",res)
        if(code==0){
          this.$message.success("手机验证码发送成功")
        }

      })
    },
    commit(){
      $network.post(
          `/p/c/checkVerificationCode`,
          {
            "tel":this.telephone,
            "captcha":this.yzm
          }
        ).then((res)=>{
          const {data:{code,message,data}} = res
          if(code==0){
            this.hash = data
            this.stepCurrent =1
          }
        })

    },
    commitNext(){
      if(!this.setPsw || !this.commitPsw){
          this.$message.warning("密码不能为空")
          return
        }
        if(this.setPsw.trim() != this.commitPsw.trim()){
          this.$message.warning("两次输入密码不一致")
          return
        }
        let params = {
          "tel":this.telephone,
          "hash":this.hash,
          "password":this.setPsw
        }
        console.log("params===",params)
         $network.post(
          `/p/c/resetPwdByHash`,
          params
        ).then((res)=>{
          const {data:{code,message,data}} = res
          if(code==0){
            this.$message.success(message)
            this.stepCurrent =2
          }
        })
      },
      commitEnd(){
        this.$router.push({path:'/login'})
      }
   },
  created() {}
};
</script>

<style lang="less" scoped>
/deep/ .ark-input{
  border:0;
  height:38px;
  border-bottom: 1px solid #797979;
  border-radius: 0;

}
/deep/ .ark-steps .ark-steps-tail > i,.ark-steps .ark-steps-tail > i{
  background: linear-gradient(to right,#fd6442,#fff);
}
.password-style{
  width: 100%;
  height: 100%;

  background: #f5f5f5;
  .header-psw{
    display: flex;
    align-items: center;
    padding: 0 20px;
    height: 60px;
    background: #fff;
    margin-bottom: 80px;
    position: relative;
    .logo {
      // position: absolute;
      width: 84px;
      vertical-align: middle;
      transform: translateY(-50px);
      filter: drop-shadow(var(--b1-color_x1) 0 50px);
      margin-right: 10px;
      // top: 17px;
      // left: 26px;
      // float: left;
    }
    .line{
      border-left: 2px solid #797979;
      height: 24px;
      width: 100px;
      font-size: 16px;
      display: inline-block;
      letter-spacing: 2px;
      line-height: 24px;

      padding-left: 10px;
     }
    .go-login{
      position: absolute;
      right: 20px;
      top:10px;
      position: absolute;
      line-height: 40px;
    font-size: 15px;

    }
  }
  .info{
    width: 800px;
    height: 430px;
    margin: auto;
    padding-top: 30px;
    background: #fff;
    .step{
      padding: 0 0 20px 100px;
      border-bottom: 3px solid #797979;
    }
    .check-info{
      width: 600px;
      margin: 0 auto;
      margin-top: 50px;
      text-align: center;
      .checkbox{
        width: 300px;
        height: 40px;
        line-height: 40px;
        margin-top: 30px;
        // background: #F7F7F7;
        background:linear-gradient(180deg, #fafafa, #f0f0f0);
        border:1px solid #797979;
        display:inline-block;
        text-align: left;
        .checkbox-info{
          img{
            display: inline;
            vertical-align: middle;
            margin-left: 8px;
          }
          .iconmd-checkmark{
            display: inline-block;
            color: #376BB7;
            font-size: 22px;
            margin-left: 8px;
          }
        }
        .yzm{
         input{
           height: 28px;
           border:none;
           margin-left: 8px;
           background: transparent;
         }
         span{
           display:inline-block;
           height: 38px;
           border-left: 1px solid #ccc;
           border-color:#797979;
           text-align: center;
           line-height: 40px;
           width: 100px;
           color: #376BB7;
         }

        }

      }
      .reset-style{
          border:1px solid #797979;
          border-bottom: none;
          width: 302px;
          display: inline-block;
          margin: 15px 0;
        }
      .passtype{
          font-size: 12px;
          width: 300px;
          margin: 0 auto;
          margin-top: -10px;
          span{
            display: inline-block;
            width: 53px;
            border-radius: 10px;
            height: 12px;
            background: #ccc;
            vertical-align: middle;
            &.passStrong{
              background: #fd6442;
            }
          }
        }
      .submit{
        width: 100%;
        height: 50px;
        padding-top: 30px;
      }
    }
    .checkfinish{
      width: 100%;
      margin-top: 220px;
      text-align: center;
    }

  }
}
</style>
